import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { UpdateHobbiesETCToFB } from "./UpdateHobbiesETCToFB";
import ToastMessage from "./ToastMessage";

export default function DisplayHobbies({ user, userData, setUserData, readOnly = false }) {
	const [editDetails, setEditDetails] = useState(false);
	const [fbStatus, setFbStatus] = useState("");
	const [toastVariant, setToastVariant] = useState("success");
	const [showToast, setShowToast] = useState(false);

	const handleEditClickMain = () => {
		if (!readOnly) {
			setEditDetails(true);
		}
	};

	const handleClose = () => {
		setEditDetails(false);
	};

	return (
		<>
			<div className="mb-3">
				<div className="position-relative">
					{!readOnly && (
						<span
							className="position-absolute top-0 end-0 my-btn rounded-circle"
							style={{
								width: "30px",
								height: "30px",
								cursor: "pointer",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
							onClick={handleEditClickMain}
						>
							<i className="bi bi-pencil-fill" style={{ fontSize: "1rem" }}></i>
						</span>
					)}
				</div>
				<p className="mt-2">
					<i className="bi bi-stars"></i> <span>Hobbies</span>
				</p>

				{userData?.hobbies?.length > 0 ? (
					userData.hobbies.map((hobby, i) => (
						<span key={i} className="badge custom-badge rounded-pill text-bg-secondary me-2 mb-1">
							<i className={`bi ${hobby.icon}`}></i> {hobby.name}
						</span>
					))
				) : (
					<div>{readOnly ? "(No hobbies listed)" : "(Add your hobbies)"}</div>
				)}

				{/* Edit Modal */}
				<Modal show={editDetails} onHide={handleClose} centered>
					<Modal.Header closeButton>
						<Modal.Title>Add your hobbies etc</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<UpdateHobbiesETCToFB
							user={user}
							userData={userData}
							setUserData={setUserData}
							handleClose={handleClose}
							setFbStatus={setFbStatus}
							setShowToast={setShowToast}
							setToastVariant={setToastVariant}
						/>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={handleClose}>
							Close
						</Button>
					</Modal.Footer>
				</Modal>
			</div>

			{/* Toast Notification */}
			<ToastMessage showToast={showToast} setShowToast={setShowToast} fbStatus={fbStatus} toastVariant={toastVariant} />
		</>
	);
}
